import styled from "styled-components";
export const Styles = styled.div`
  #administrativeStaffSection {
    position: relative;
    margin-top:80px;
    margin-bottom:40px;
  }
  #administrativeStaffSection .react-img {
    position: absolute;
    height: 70%;
    top: -250px;
    left: -140px;
    z-index: -1;
  }
  #administrativeStaffSection .row{
    justify-content: center;
  }
  #administrativeStaffSection .item {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    margin-bottom: 20px;
  }
  #administrativeStaffSection .item .item-img {
    width: 230px;
    height: 230px;
    margin-bottom: 20px;
    border-radius: 50%;
    overflow: hidden;
  }
  #administrativeStaffSection .item .item-img img {
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
  }
  .avatar{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .avatar #user{
    width: 100%;
    height: 50%;
  }
  #administrativeStaffSection .item .item-description .name {
    font-size: 18px;
    color: var(--dark-purple);
    margin-bottom: 10px;
  }
  #administrativeStaffSection .item .item-description .job-title {
    font-size: 15px;
    color: var(--dark-color);
  }
  @media (max-width: 1080px) {
    #administrativeStaffSection .react-img {
      height: 40%;
    }
  }
  @media (max-width: 768px) {
    #administrativeStaffSection .react-img {
      height: 20%;
    }
  }
`;
